<template>
  <div id="SiteGuestQRCodeDialog_main">
    <el-dialog
      :title="$t('Guest.SiteQRCode.Title')"
      :visible.sync="dialogVisible"
      custom-class="QRCodePopup"
      width="40%"
    >
      <p class="info">
        {{ $t('Guest.SiteQRCode.ScanInstruction') }}
      </p>
      <div
        v-loading="loading"
        class="qrcodeDiv"
        :class="{'invalid': hasError}"
      >
        <div class="qrcodeWrap">
          <div
            v-if="hasError"
            class="errorOverlay"
            @click="loadQrCode"
          >
            <i
              class="icon-refresh"
              aria-hidden="true"
            />
          </div>
          <vue-qr
            :correct-level="0"
            :dot-scale="1"
            :logo-src="require('@/assets/img/GuestPrint/Logo_for_register@3x.png')"
            :text="`${qrcoderouter}/mgmt/visitorRealNameRigistration?AuthorizationCode=${qrcodeData}`"
            :logo-background-color="'#fff'"
            :logo-margin="0"
            :logo-scale="0.3"
            :logo-corner-radius="20"
            :size="500"
          />
        </div>
      </div>
      <p
        v-if="hasError"
        class="errorTip"
        @click="loadQrCode"
      >
        {{ $t('Guest.SiteQRCode.LoadFailed') }}
      </p>
      <el-divider />
      <el-button
        :disabled="!canClickButton"
        type="primary"
        class="printButton"
        round
        @click="print"
      >
        {{ $t('Guest.SiteQRCode.Print') }}
      </el-button>
    </el-dialog>
    <!-- 列印渲染區塊，已隱藏 -->
    <div
      id="printPage"
      ref="printPage"
      class="printPage"
    >
      <p class="title">
        {{ communityName }}
      </p>
      <p class="info">
        {{ $t('Guest.SiteQRCode.PrintInstruction') }}
      </p>
      <vue-qr
        class="printSiteQRCode"
        :correct-level="0"
        :dot-scale="1"
        :logo-src="require('@/assets/img/GuestPrint/Logo_for_register@3x.png')"
        :text="`${qrcoderouter}/mgmt/visitorRealNameRigistration?AuthorizationCode=${qrcodeData}`"
        :logo-background-color="'#fff'"
        :logo-margin="0"
        :logo-scale="0.3"
        :logo-corner-radius="20"
        :size="450"
        :margin="30"
      />
      <img
        src="../../../assets/img/GuestPrint/ADpic@3x.png"
        alt="社區服務介紹"
        width="80%"
        style="margin-bottom: 14%"
      >
      <img
        src="../../../assets/img/GuestPrint/SearchAD@3x.png"
        alt="搜尋智生活"
        width="30%"
        style="position: absolute; bottom: -0.8%; left: 35%;"
      >
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dialogVisible: false,
      qrcodeData: '',
      communityName: JSON.parse(localStorage.getItem('loginUserInfo')).CommunityName,
      canClickButton: true, // 防止連點button參數
      // eslint-disable-next-line eqeqeq
      qrcoderouter: (process.env.NODE_ENV == 'development') ? 'https://local.kingnetsmart.com.tw/' : window.location.origin,
      loading: false,
      hasError: false
    }
  },
  methods: {
    openDialog () {
      this.hasError = false
      this.loading = true
      this.dialogVisible = true
      setTimeout(() => {
        this.loadQrCode()
      }, 1000)
    },
    async loadQrCode () {
      this.hasError = false
      this.loading = true
      try {
        const res = await apiGuest.GuestRecordTabs.GetRegisterFormUrl()
        if (!res.data) {
          this.hasError = true
        } else {
          this.qrcodeData = res.data
        }
      } catch (err) {
        console.log('錯誤訊息：', err.response)
        this.hasError = true
      } finally {
        this.loading = false
      }
    },
    closeDialog () {
      this.dialogVisible = false
    },
    // 列印
    print () {
      if (this.canClickButton) {
        this.canClickButton = false
        this.fullScreenLoading(true)
        this.$print(this.$refs.printPage)
        this.fullScreenLoading(false)
        setTimeout(() => {
          this.canClickButton = true
        }, 500)
      }
    },
    fullScreenLoading (display) {
      const loadingWrap = this.$loading({
        lock: true,
        text: '資料處理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (!display) { loadingWrap.close() }
    }
  }
}
</script>
<style lang="sass" scoped>
#SiteGuestQRCodeDialog_main
  ::v-deep .el-dialog.QRCodePopup
    +basicDialog
    min-width: 500px
    .info
      margin-bottom: 8px
    .qrcodeDiv
      height: 262px
      display: flex
      align-items: center
      justify-content: center
      .qrcodeWrap
        position: relative
        display: inline-block
        line-height: 0
        .errorOverlay
          position: absolute
          top: 0
          left: 0
          width: 100%
          height: 100%
          z-index: 9
          cursor: pointer
          display: flex
          align-items: center
          justify-content: center
          .icon-refresh
            font-size: 60px
            color: $mainFontColor
      &.invalid
        img
          opacity: 0.2
    .errorTip
      color: $dangerColor
      text-align: center
      margin-top: 8px
      cursor: pointer
    .el-divider
      margin: 16px 0
  .printPage
    display: none
</style>
<style lang="scss" scoped>
@media print{
  * {
    -webkit-print-color-adjust: exact !important;
  }
  .printPage{
    border: #8E8E8E 1px solid;
    border-radius: 24px;
    text-align: center;
    background-color: $white;
    position: relative;
    @page{
      size: A4 portrait;
    }
    .title{
      color: $mainColor;
      font-weight: bold;
      font-size: 35px;
      margin-top: 5%;
    }
    .info{
      font-size: 25px;
      margin-top: 2%;
    }
    .printSiteQRCode{
      margin-bottom: 2%;
    }
  }
}
</style>
